import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Enrolement from './Enrolement';
import Recherche from './Recherche';
import Import from './Import';
import Export from './Export';
import Statistiques from './Statistiques';
import Utilisateurs from './Utilisateurs';
import Profil from './Profil';
import Bureaux from './Bureaux';
import Cellules from './Cellules';
import Grades from './Grades';
import Fonctions from './Fonctions';
import CategoriesProfessionnelles from './CategoriesProfessionnelles';

const Dashboard = ({ onLogout, user: initialUser }) => {
  const [activeSection, setActiveSection] = useState('statistiques');
  const [user, setUser] = useState(initialUser);

  useEffect(() => {
    if (initialUser) {
      setUser(initialUser);
    } else {
      // Récupérer l'utilisateur depuis localStorage
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        try {
          setUser(JSON.parse(storedUser));
        } catch (error) {
          console.error('Erreur lors du parsing de l\'utilisateur:', error);
        }
      }
    }
  }, [initialUser]);

  const renderSection = () => {
    switch (activeSection) {
      case 'enrolement':
        return <Enrolement />;
      case 'recherche':
        return <Recherche />;
      case 'import':
        return <Import />;
      case 'export':
        return <Export />;
      case 'statistiques':
        return <Statistiques />;
      case 'utilisateurs':
        return <Utilisateurs />;
      case 'bureaux':
        return <Bureaux />;
      case 'cellules':
        return <Cellules />;
      case 'grades':
        return <Grades />;
      case 'fonctions':
        return <Fonctions />;
      case 'categories-professionnelles':
        return <CategoriesProfessionnelles />;
      case 'profil':
        return <Profil user={user} />;
      default:
        return <Statistiques />;
    }
  };

  return (
    <div className="flex h-screen overflow-hidden bg-background font-sans antialiased">
      <Sidebar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        onLogout={onLogout}
        user={user}
      />
      <main className="flex-1 overflow-y-auto">{renderSection()}</main>
    </div>
  );
};

export default Dashboard;

